































import Vue from 'vue'
import Component from 'vue-class-component'
import UserList from '@/modules/user/components/UserList.vue'
import {Prop} from 'vue-property-decorator'
import User from '@/modules/user/model/User'

/**
 * Componente que muestra la lista de usuarios y permite seleccionar uno
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        UserList,
    },
})
export default class UserSelect extends Vue {
    /**
     * Controla la visibilidad del modal
     */
    @Prop({type: Boolean, default: false})
    public show: boolean

    public currentUserListPage = 1
    public totalPages = 0
}
